import { createSelector } from '@reduxjs/toolkit';
import type { SpatialLayer } from '../../GlobalMapSearch.types';

const EMPTY: SpatialLayer[] = [];

const selectStaticLayers = (state: unknown): SpatialLayer[] => {
  const slice = (state as { spatialLayers?: { staticLayers?: SpatialLayer[] } })
    .spatialLayers?.staticLayers;
  return slice ?? EMPTY;
};

/**
 * Active (user-toggled-on) static spatial layers. Mirrors how GIS layers use
 * `selectActiveLayers` — only layers checked in the map controls are
 * eligible for search.
 */
export const selectActiveStaticLayers = createSelector(
  [selectStaticLayers],
  layers => layers.filter(l => l.isChecked),
);
